import api from '@/api/Api'

export default async (to) => {
  if (to.query.requestDomain) {
    api.setDefaultQueryString({ requestDomain: to.query.requestDomain })
  }

}
